<template>
  <div>
    <password-field
        ref="password"
        refName='password'
        class="m-b-4"
        :class="{ 'error': validation.hasError('password') }"
        :error="validation.firstError('password')"
        :disabled="loading"
        v-model="password"
    />
    <password-field
        ref="password2"
        refName="password2"
        :class="{ 'error': validation.hasError('password2') }"
        :error="validation.firstError
        ('password2')"
        label="Re-enter Password"
        :disabled="loading"
        v-model="password2"
    />
  </div>
</template>

<script>
import SimpleVueValidator, { Validator } from 'simple-vue-validator';
import PasswordField from '@/components/PasswordField';
import { passwordValidator } from '@/utils/password-validator';

export default {
  name: 'password-fields',
  components: {
    PasswordField,
  },
  mixins: [SimpleVueValidator.mixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      password: '',
      password2: '',
      loading: false,
    };
  },
  validators: {
    password (value) {
      return passwordValidator(value);
    },
    'password2, password': (password2, password) => {
      return Validator.value(password2)
        .required('Please enter Confirm Password.')
        .match(password, 'Password and Confirmation do not match.');
    },
  },
  methods: {
    async reset () {
      this.password = '';
      this.password2 = '';
      this.validation.reset();
      await this.$refs.password.reset();
      await this.$refs.password2.reset();
    },
    getPassword () {
      return this.password;
    },
  },
};
</script>
